import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Arrow from 'rebook/apps/dashboard/components/DashboardArrow';

import styles from './style.scss';


const FakeVerticalBookCard = ({ text, url }) => {
  return (
    <Link className={classNames(
      styles.fakeBookWrapper,
      'swiper-slide',
    )}
    to={url}
    target="_blank">
      {text}
      <Arrow extraClassName={styles.arrow} />
    </Link>
  );
};


FakeVerticalBookCard.propTypes = {
  text: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default FakeVerticalBookCard;
